/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	OrganisationUpdateAccessModePathParams,
	OrganisationUpdateAccessModeRequest,
	OrganisationUpdateAccessModeResponse,
} from '../types/OrganisationUpdateAccessMode'

/**
 * PATCH /organisations/:organisation/access-mode
 * @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationController.php OrganisationController::updateAccessMode
 */
export async function organisationUpdateAccessMode(
	organisation: OrganisationUpdateAccessModePathParams['organisation'],
	data: OrganisationUpdateAccessModeRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<OrganisationUpdateAccessModeResponse>> {
	return axiosInstance.patch(`/organisations/${organisation}/access-mode`, data, config)
}
